export const setClientGroupSuggestions = payload => ({
  type: "FETCH_CLIENT_GROUP_SUGGESTIONS",
  payload
});

export const setFilterClientGroup = groups => {
  return {
    type: "SET_FILTER_CLIENT_GROUP",
    groups
  };
};

export const initFilterClient = () => {
  return {
    type: "INIT_CLIENT_SUGGESTIONS"
  };
};

export const initFilterCollaborator = () => {
  return {
    type: "INIT_COLLABORATOR_SUGGESTIONS"
  };
};

export const setClientSuggestions = payload => ({
  type: "FETCH_CLIENT_SUGGESTIONS",
  payload
});

export const setFilterClient = clients => {
  return {
    type: "SET_FILTER_CLIENT",
    clients
  };
};

export const setCollaboratorsSuggestions = payload => ({
  type: "FETCH_COLLABORATOR_SUGGESTIONS",
  payload
});

export const setFilterCollaborators = collaborators => {
  return {
    type: "SET_FILTER_COLLABORATOR",
    collaborators
  };
};

export const setFilterCollaboratorRole = role => {
  return {
    type: "SET_FILTER_COLLABORATOR_ROLE",
    role
  };
};

export const setTaskCategorySuggestions = payload => ({
  type: "FETCH_TASK_CATEGORY_SUGGESTIONS",
  payload
});

export const setFilterTaskCategory = types => {
  return {
    type: "SET_FILTER_TASK_CATEGORY",
    types
  };
};
export const setFilterPeriodUnit = unit => {
  return {
    type: "SET_FILTER_PERIOD_UNIT",
    unit
  };
};

export const setFilterPeriods = periods => {
  return {
    type: "SET_FILTER_PERIODS",
    periods
  };
};
export const setFilterYear = year => {
  return {
    type: "SET_FILTER_YEAR",
    year
  };
};

export const setZonesSuggestions = payload => ({
  type: "FETCH_ZONE_SUGGESTIONS",
  payload
});

export const setFilterZone = zones => {
  return {
    type: "SET_FILTER_ZONE",
    zones
  };
};

export const setBusinessUnitSuggestions = payload => ({
  type: "FETCH_BUSINESS_UNIT_SUGGESTIONS",
  payload
});

export const setFilterBusinessUnit = bu => {
  return {
    type: "SET_FILTER_BUSINESS_UNIT",
    bu
  };
};

export const initSquads = () => {
  return { type: "INIT_SQUAD_SUGGESTIONS" };
};

export const fetchSquadsSuggestions = payload => ({
  type: "FETCH_SQUAD_SUGGESTIONS",
  payload
});

export const setFilterSquads = squads => {
  return { type: "SET_FILTER_SQUAD", squads };
};

export const initClusters = () => {
  return { type: "INIT_CLUSTER_SUGGESTIONS" };
};

export const fetchClusterSuggestions = payload => ({
  type: "FETCH_CLUSTER_SUGGESTIONS",
  payload
});

export const setFilterCluster = clusters => {
  return { type: "SET_FILTER_CLUSTER", clusters };
};

export const setFilterEntity = (entityClientId, isEntity) => {
  return {
    type: "SET_FILTER_ENTITY",
    payload: { entityClientId, isEntity }
  };
};

export const setClientsIsEntityState = isEntity => {
  return {
    type: "SET_CLIENT_IS_ENTITY_FILTER_STATE",
    payload: { isEntity }
  };
};

export const setClientsStatusBudgetEco = statusBudgetEco => {
  return {
    type: "SET_CLIENT_STATUS_BUDGET_ECO",
    payload: statusBudgetEco
  };
};

export const setClientsDeletedStatus = selectedStatus => {
  return {
    type: "SET_CLIENT_DELETED_STATUS",
    payload: selectedStatus
  };
};

export const setClientsOffshoreStatus = selectedStatus => {
  return {
    type: "SET_CLIENT_OFFSHORE_STATUS",
    payload: selectedStatus
  };
};
export const setClientsFacturableStatus = selectedStatus => {
  return {
    type: "SET_CLIENT_FACTURABLE_STATUS",
    payload: selectedStatus
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/filter.js